import axios from "axios";
import config from "app/api/axiosConfig";

export default (token: string, id: string) =>
  axios.delete(
    `${process.env.REACT_APP_API_HOST}/admin/page?id=${id}`,
    config(token)
  );
